module.exports = __webpack_public_path__ + "static/img/policyType7-title.8cc99ca5.png";